import React from 'react'
import { Route, Switch } from 'react-router-dom'

import HomeContainer from './containers/HomeContainer'
import CreateWalletContainer from './containers/CreateWalletContainer'
import RestoreWalletContainer from './containers/RestoreWalletContainer'
import BackupWalletContainer from './containers/BackupWalletContainer'
import ReceiveWalletContainer from './containers/ReceiveWalletContainer'
import UnlockWalletContainer from './containers/UnlockWalletContainer'
import PrivateKeyContainer from './containers/PrivateKeyContainer'
import PasswordChangeContainer from './containers/PasswordChangeContainer'
import NotFoundContainer from './containers/NotFoundContainer'

import {
  HOME,
  CREATE_WALLET_NAV, 
  RESTORE_WALLET_NAV, 
  BACKUP_WALLET_NAV, 
  RECEIVE_WALLET_NAV, 
  UNLOCK_WALLET_NAV, 
  PRIVATE_KEY_NAV, 
  PASSWORD_CHANGE_NAV 
} from './constants/navigation'

const Routes = () => (  
  <Switch>
    <Route path={HOME} exact component={HomeContainer} />    
    <Route path={CREATE_WALLET_NAV} exact component={CreateWalletContainer} />
    <Route path={RESTORE_WALLET_NAV} exact component={RestoreWalletContainer} />
    <Route path={BACKUP_WALLET_NAV} exact component={BackupWalletContainer} />
    <Route path={RECEIVE_WALLET_NAV} exact component={ReceiveWalletContainer} />
    <Route path={UNLOCK_WALLET_NAV} exact component={UnlockWalletContainer} />
    <Route path={PRIVATE_KEY_NAV} exact component={PrivateKeyContainer} />
    <Route path={PASSWORD_CHANGE_NAV} exact component={PasswordChangeContainer} />
    <Route component={NotFoundContainer} />
  </Switch>  
)  

export default Routes
  


// WEBPACK FOOTER //
// ./src/Routes.js